export default "__VITE_ASSET__CRHMgz3g__"